import React, {useState, useEffect} from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
  import axios from "axios";
  import { apiUrl } from "../../config/Config";
  import { useSelector, useDispatch } from "react-redux";
  import { useNavigate, useParams } from "react-router-dom";

const EditCoupon = () => {
  const userdata = useSelector((store) => store.userReducer.userdata);
  const dispatch = useDispatch();
  const { id } = useParams();

    const [name, setname] = useState("");
    const [code, setcode] = useState("");
    const [type, settype] = useState("");
    const [cartvalue, setcartvalue] = useState("");
    const [discountvalue, setdiscountvalue] = useState("");
    const [limits, setlimits] = useState("");
    const [startdate, setstartdate] = useState("");
    const [enddate, setenddate] = useState("");
    const [starttime, setstarttime] = useState("");
    const [endtime, setendtime] = useState("");
    const [description, setdescription] = useState("")
    const [status, setstatus] = useState("true");

    const navigate = useNavigate();

    const handlesubmitcoupon = async() => {
      if (!name.trim() || !code.trim() || !type) {
        alert("Please enter coupon name, code, and type");
        return;
      }

      if (!cartvalue || !discountvalue) {
        alert(type === "buyxgety" ? "Please enter BUY X and GET Y quantities" : "Please enter cart value and discount value");
        return;
      }

      if (type === "disacountpercent" && Number(discountvalue) > 100) {
        alert("Discount percent cannot be more than 100");
        return;
      }

      var data = {
        id: id,
        name: name.trim(),
        code: code.trim().toUpperCase(),
        type: type,
        cartvalue: cartvalue,
        discountvalue: discountvalue,
        limits: limits,
        startdate: startdate,
        starttime: starttime,
        enddate: enddate,
        endtime: endtime,
        description: description,
        status: status
      }
      console.log('data >>', data);
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userdata?.token,
        },
      };
      await axios
        .post(apiUrl + "updatecoupon",data, headers)
        .then((res) => {
          // console.log('res >>', res.data)
          // category data
          if (res?.data?.status === "success") {
            navigate('/admin/coupons')
          } else {
            if (res.data.message === "invalid user") {
              dispatch({ type: "userdata", payload: {} });
              navigate("/admin/login");
            } else {
              alert(res.data.message);
            }
          }
        })
        .catch((err) => {
          console.log("err >>", err);
        });

      console.log("data >>", data);
      // 
    }

    const fetchproductdetails = async(id) => {
        const headers = {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + userdata?.token,
            },
          };
    
          var data = {
            id: id
          }
          await axios
            .post(apiUrl + "fetchcoupondetails", data, headers)
            .then((res) => {
              // console.log('res >>', res.data)
              // category data
              if (res?.data?.status === "success") {
                //category data
               console.log('res data >>>', res?.data);
               var prevdata = res?.data?.data;
               setname(prevdata?.name)
               setcode(prevdata?.code)
               settype(prevdata?.type)
               setcartvalue(prevdata?.cartvalue)
               setdiscountvalue(prevdata?.discountvalue)
               setlimits(prevdata?.limits)
               setstartdate(prevdata?.startdate)
               setenddate(prevdata?.enddate)
               setstarttime(prevdata?.starttime)
               setendtime(prevdata?.endtime)
               setdescription(prevdata?.description)
               setstatus(prevdata?.status || "true")
            //    setproductname(prevdata?.name);
            //    setselectedcategory(prevdata?.category);
            //    setmrpprice(prevdata?.mrpprice);
            //    setsellingprice(prevdata?.sellingprice);
            //    setstock(prevdata?.stock);
    
    
              } else {
                if (res.data.message === "invalid user") {
                  dispatch({ type: "userdata", payload: {} });
                  navigate("/admin/login");
                } else {
                  alert(res.data.message);
                }
              }
            })
            .catch((err) => {
              console.log("err >>", err);
            });
      }

    const handleTypeChange = (nextType) => {
      settype(nextType);
      setcartvalue("");
      setdiscountvalue("");
    };

    useEffect(() => {
        if (userdata && Object.keys(userdata).length > 0) {
          fetchproductdetails(id);
        //   fetchdata();
        } else {
          navigate("/admin/login");
        }
      }, [id, userdata, navigate]);

    return (
      <div className="">
        <div className="dashboardbox" style={{ width: "100%" }}>
          <div className="inventorysave-row addproduct-save-row">
            <p className="inventorysummary-text addproduct-text">
              Generate Discount Coupons
            </p>
            {/* <div className="inventory-save-btn add-product-btn add-product-btn1">
              <p>Save as draft</p>
            </div> */}
            <div className="inventory-save-btn add-product-btn" style={{marginLeft: 'auto'}} onClick={handlesubmitcoupon}>
              <p>Update</p>
            </div>
          </div>
          <div className="inventorysummaryrow row mt-3">
            <div className="col-md-4">
              <div className="">
                <label className="addproduct-label">Name</label>
                <input
                value={name}
                onChange={(t) => {setname(t.target.value)}}
                  className="form-control addproductinput"
                  placeholder="Name of Coupon"
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Code</label>
                <input
                value={code}
                onChange={(t) => {setcode(t.target.value.toUpperCase())}}
                  className="form-control addproductinput"
                  placeholder="XXXXXXX"
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Type</label>
                <select
                  className="form-control addproductinput"
                  value={type}
                  onChange={(t) => {
                    handleTypeChange(t.target.value);
                  }}
                >
                  <option value={""} disabled>
                    Select discount type
                  </option>
                  <option value={"disacountamount"}>Discount Amount</option>
                  <option value={"disacountpercent"}>Discount Percent</option>
                  <option value={"buyxgety"}>BUY X GET Y</option>
                </select>
              </div>
              {type === "disacountamount" ? (
                <div className="row mt-3">
                  <div className="col-md-6">
                    <label className="addproduct-label">Min Cart Value</label>
                    <input
                    value={cartvalue}
                    onChange={(t) => {setcartvalue(t.target.value)}}
                      type="number"
                      className="form-control addproductinput"
                      placeholder="Enter Amount"
                    />
                    <small className="coupon-config-help-text">Coupon applies when cart subtotal reaches this amount.</small>
                  </div>
                  <div className="col-md-6">
                    <label className="addproduct-label">Discount Amount</label>
                    <input
                    value={discountvalue}
                    onChange={(t) => {setdiscountvalue(t.target.value)}}
                      type="number"
                      className="form-control addproductinput"
                      placeholder="Enter Amount"
                    />
                    <small className="coupon-config-help-text">Flat discount in rupees.</small>
                  </div>
                </div>
              ) :
              type === "disacountpercent" ?
                <div className="row mt-3">
                  <div className="col-md-6">
                    <label className="addproduct-label">Min Cart Value</label>
                    <input
                     value={cartvalue}
                     onChange={(t) => {setcartvalue(t.target.value)}}
                      type="number"
                      className="form-control addproductinput"
                      placeholder="Enter Amount"
                    />
                    <small className="coupon-config-help-text">Coupon applies when cart subtotal reaches this amount.</small>
                  </div>
                  <div className="col-md-6">
                    <label className="addproduct-label">Discount %</label>
                    <input
                    value={discountvalue}
                    onChange={(t) => {setdiscountvalue(t.target.value)}}
                      type="number"
                      className="form-control addproductinput"
                      placeholder="Enter Percent"
                    />
                    <small className="coupon-config-help-text">Percentage discount, maximum 100.</small>
                  </div>
                </div>
                :
                type === "buyxgety" ?
                <div className="row mt-3">
                  <div className="col-md-6">
                    <label className="addproduct-label">BUY X</label>
                    <input
                    value={cartvalue}
                    onChange={(t) => {setcartvalue(t.target.value)}}
                      type="number"
                      className="form-control addproductinput"
                      placeholder="Enter Quantity"
                    />
                    <small className="coupon-config-help-text">Paid item quantity in each group.</small>
                  </div>
                  <div className="col-md-6">
                    <label className="addproduct-label">GET Y</label>
                    <input
                    value={discountvalue}
                    onChange={(t) => {setdiscountvalue(t.target.value)}}
                      type="number"
                      className="form-control addproductinput"
                      placeholder="Enter Quantity"
                    />
                    <small className="coupon-config-help-text">Free cheapest item quantity in each group.</small>
                  </div>
                </div>
              : null}
              <div className="mt-3">
                <label className="addproduct-label">Usage Limits</label>
                <input
                value={limits}
                onChange={(t) => {setlimits(t.target.value)}}
                  type="number"
                  className="form-control addproductinput"
                  placeholder="Limit"
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Status</label>
                <select
                  className="form-control addproductinput"
                  value={status}
                  onChange={(t) => setstatus(t.target.value)}
                >
                  <option value="true">Active</option>
                  <option value="false">Draft / Inactive</option>
                </select>
              </div>
            </div>
            <div className="col-md-4">
            <div className="row">
                <div className="col-md-6">
                  <label className="addproduct-label">Start Date</label>
                  <input
                  value={startdate}
                  onChange={(t) => {setstartdate(t.target.value)}}
                    type="date"
                    className="form-control addproductinput"
                    placeholder="Enter Amount"
                  />
                </div>
                <div className="col-md-6">
                  <label className="addproduct-label">Time</label>
                  <input
                  value={starttime}
                  onChange={(t) => {setstarttime(t.target.value)}}
                    type="time"
                    className="form-control addproductinput"
                    placeholder="Enter Amount"
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-6">
                  <label className="addproduct-label">End Date</label>
                  <input
                  value={enddate}
                  onChange={(t) => {setenddate(t.target.value)}}
                    type="date"
                    className="form-control addproductinput"
                    placeholder="Enter Amount"
                  />
                </div>
                <div className="col-md-6">
                  <label className="addproduct-label">Time</label>
                  <input
                  value={endtime}
                  onChange={(t) => {setendtime(t.target.value)}}
                    type="time"
                    className="form-control addproductinput"
                    placeholder="Enter Amount"
                  />
                </div>
              </div>
              <div className="mt-3">
              <label className="addproduct-label">Description</label>
                <textarea
                value={description}
                onChange={(t) => {setdescription(t.target.value)}}
                  className="form-control addproductinput"
                  style={{ height: 135 }}
                  placeholder="Short Description"
                ></textarea>
              </div>
            </div>
            <div className="col-md-4">
            </div>
          </div>
        </div>
      </div>
    );
}

export default EditCoupon;
